import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

// @ts-ignore
import logo from "../../assets/images/logo_white.svg";
import { toggleSidebarMobile } from "../../utils/sidebarUtils";
import { useAuth } from "../../contexts/AuthContext";

export const Sidebar = () => {
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      logout();
      handleClose();
    }
  };

  // Close sidebar on route change
  const handleNavClick = () => {
    handleClose();
  };

  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        handleClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen]);

  return (
    <>
      {/* Floating Toggle Button */}
      <button
        className={`sidebar-toggle-btn ${isOpen ? "active" : ""}`}
        onClick={handleToggle}
        aria-label={isOpen ? "Close menu" : "Open menu"}
      >
        <span className="line line-1"></span>
        <span className="line line-2"></span>
        <span className="line line-3"></span>
      </button>

      {/* Backdrop Overlay */}
      {isOpen && <div className="sidebar-backdrop" onClick={handleClose}></div>}

      {/* Sidebar */}
      <aside className={`account-sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <div className="logo-wrapper">
            <img alt="Arture Logo" className="logo" src={logo} />
          </div>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-items">
            <li>
              <NavLink
                onClick={handleNavClick}
                to="/account/dashboard"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <i className="fa fa-tachometer-alt"></i>
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={handleNavClick}
                to="/account/work"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <i className="fa fa-tasks"></i>
                <span>Work</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={handleNavClick}
                to="/account/components"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <i className="fa fa-palette"></i>
                <span>Components</span>
              </NavLink>
            </li>
          </ul>
        </nav>

        <div className="sidebar-footer">
          {user && (
            <div className="user-info">
              <div className="user-avatar">
                <i className="fas fa-user-circle"></i>
              </div>
              <div className="user-details">
                <span className="user-name">{user.username || "User"}</span>
                <span className="user-role">Admin</span>
              </div>
            </div>
          )}
          <button className="logout-btn" onClick={handleLogout}>
            <i className="fas fa-right-from-bracket"></i>
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};
